import { env } from '@/root/env.mjs';

import { type ApiConfig } from './apiConfigTypes';
import { apiDevConfig } from './apiDev.config';
import { apiProdConfig } from './apiProd.config';
import { apiStageConfig } from './apiStage.config';

export function getDefaultConfig(): ApiConfig {
  switch (env.NEXT_PUBLIC_ENVIRONMENT) {
    case 'production':
      return apiProdConfig;
    case 'stage':
      return apiStageConfig;
    case 'dev':
    default:
      return apiDevConfig;
  }
}
